import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import React, { useContext, useRef, useEffect, useState } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { Checkbox } from '../index';

var InternalOption = function InternalOption(props, ref) {
  var _classNames;

  var optionRef = useRef(null) || ref;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSelected = _useState2[0],
      setSelected = _useState2[1];

  var className = props.className,
      children = props.children,
      _props$value = props.value,
      value = _props$value === void 0 ? null : _props$value,
      disabled = props.disabled,
      values = _valuesInstanceProperty(props),
      isMultiple = props.isMultiple,
      onChangeSelect = props.onChangeSelect;

  var optionProps = _extends({}, props);

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var selectOptionPrefixCls = getPrefixCls(prefixCls, 'select-item');
  useEffect(function () {
    if (isMultiple) {
      setSelected((values === null || values === void 0 ? void 0 : values.indexOf(value)) > -1);
    } else {
      setSelected(value !== undefined ? value === values : false);
    }
  });
  var optionCls = classNames(selectOptionPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(selectOptionPrefixCls, "-option"), true), _defineProperty(_classNames, "".concat(selectOptionPrefixCls, "-option-selected"), isSelected), _defineProperty(_classNames, "".concat(selectOptionPrefixCls, "-option-disabled"), disabled), _classNames));
  var contentCls = classNames(_defineProperty({}, "".concat(selectOptionPrefixCls, "-option-content"), true));

  var handleClick = function handleClick(e) {
    e.preventDefault();
    if (optionProps.disabled || value === undefined) return;

    if (isMultiple) {
      setSelected(!isSelected);
    }

    onChangeSelect && onChangeSelect(value, children, isSelected);
  };

  var titleText = _typeof(children) !== 'object' ? children : null;
  var checkStyle = {
    height: '22px',
    background: 'none'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: optionRef,
    className: optionCls,
    title: titleText,
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: contentCls
  }, isMultiple ? /*#__PURE__*/React.createElement(Checkbox, {
    style: checkStyle,
    value: value,
    disabled: disabled,
    checked: isSelected
  }, children) : children)));
};

var Option = /*#__PURE__*/React.forwardRef(InternalOption);
Option.displayName = 'Option';
export default Option;